var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row justify-end mb-3"},[_c('Create')],1),_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }